import {
  STRING_getInstance3lkmlozu5h7cs as STRING_getInstance,
  INT_getInstance2jk920d18c81r as INT_getInstance,
  BOOLEAN_getInstance1zgqob6plbafc as BOOLEAN_getInstance,
  DOUBLE_getInstancehisd1jhl157p as DOUBLE_getInstance,
  LONG_getInstance3dslxry3kuylr as LONG_getInstance,
  BYTE_getInstance3pm2k5kbbzz0g as BYTE_getInstance,
  SHORT_getInstancef43vhew9c0zf as SHORT_getInstance,
  CHAR_getInstance13nfcvgyx04s8 as CHAR_getInstance,
  FLOAT_getInstance10ku33lzbmw7c as FLOAT_getInstance,
} from '../descriptors/SerialKinds.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../descriptors/SerialDescriptor.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from './ObjectSerializer.mjs';
import { initBuiltins3cd82qqvse108 as initBuiltins } from './Platform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
var StringSerializerClass;
function StringSerializer() {
  if (StringSerializerClass === VOID) {
    class $ {
      constructor() {
        StringSerializer_instance = this;
        this.a25_1 = new (PrimitiveSerialDescriptor())('kotlin.String', STRING_getInstance());
      }
      a1n() {
        return this.a25_1;
      }
      b25(encoder, value) {
        return encoder.w1s(value);
      }
      b1n(encoder, value) {
        return this.b25(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      c1n(decoder) {
        return decoder.m1r();
      }
    }
    initMetadataForObject($, 'StringSerializer', VOID, VOID, [KSerializer()]);
    StringSerializerClass = $;
  }
  return StringSerializerClass;
}
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance === VOID)
    new (StringSerializer())();
  return StringSerializer_instance;
}
var IntSerializerClass;
function IntSerializer() {
  if (IntSerializerClass === VOID) {
    class $ {
      constructor() {
        IntSerializer_instance = this;
        this.c25_1 = new (PrimitiveSerialDescriptor())('kotlin.Int', INT_getInstance());
      }
      a1n() {
        return this.c25_1;
      }
      d25(encoder, value) {
        return encoder.r1s(value);
      }
      b1n(encoder, value) {
        return this.d25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      c1n(decoder) {
        return decoder.h1r();
      }
    }
    initMetadataForObject($, 'IntSerializer', VOID, VOID, [KSerializer()]);
    IntSerializerClass = $;
  }
  return IntSerializerClass;
}
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance === VOID)
    new (IntSerializer())();
  return IntSerializer_instance;
}
var BooleanSerializerClass;
function BooleanSerializer() {
  if (BooleanSerializerClass === VOID) {
    class $ {
      constructor() {
        BooleanSerializer_instance = this;
        this.e25_1 = new (PrimitiveSerialDescriptor())('kotlin.Boolean', BOOLEAN_getInstance());
      }
      a1n() {
        return this.e25_1;
      }
      f25(encoder, value) {
        return encoder.o1s(value);
      }
      b1n(encoder, value) {
        return this.f25(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      c1n(decoder) {
        return decoder.e1r();
      }
    }
    initMetadataForObject($, 'BooleanSerializer', VOID, VOID, [KSerializer()]);
    BooleanSerializerClass = $;
  }
  return BooleanSerializerClass;
}
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance === VOID)
    new (BooleanSerializer())();
  return BooleanSerializer_instance;
}
var DoubleSerializerClass;
function DoubleSerializer() {
  if (DoubleSerializerClass === VOID) {
    class $ {
      constructor() {
        DoubleSerializer_instance = this;
        this.g25_1 = new (PrimitiveSerialDescriptor())('kotlin.Double', DOUBLE_getInstance());
      }
      a1n() {
        return this.g25_1;
      }
      h25(encoder, value) {
        return encoder.u1s(value);
      }
      b1n(encoder, value) {
        return this.h25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      c1n(decoder) {
        return decoder.k1r();
      }
    }
    initMetadataForObject($, 'DoubleSerializer', VOID, VOID, [KSerializer()]);
    DoubleSerializerClass = $;
  }
  return DoubleSerializerClass;
}
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance === VOID)
    new (DoubleSerializer())();
  return DoubleSerializer_instance;
}
var LongSerializerClass;
function LongSerializer() {
  if (LongSerializerClass === VOID) {
    class $ {
      constructor() {
        LongSerializer_instance = this;
        this.i25_1 = new (PrimitiveSerialDescriptor())('kotlin.Long', LONG_getInstance());
      }
      a1n() {
        return this.i25_1;
      }
      j25(encoder, value) {
        return encoder.s1s(value);
      }
      b1n(encoder, value) {
        return this.j25(encoder, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      c1n(decoder) {
        return decoder.i1r();
      }
    }
    initMetadataForObject($, 'LongSerializer', VOID, VOID, [KSerializer()]);
    LongSerializerClass = $;
  }
  return LongSerializerClass;
}
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance === VOID)
    new (LongSerializer())();
  return LongSerializer_instance;
}
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().u4(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer())) ? tmp : THROW_CCE();
}
function checkNameIsNotAPrimitive(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var values = get_BUILTIN_SERIALIZERS().w4();
  var _iterator__ex2g4s = values.p1();
  while (_iterator__ex2g4s.q1()) {
    var primitive = _iterator__ex2g4s.r1();
    var primitiveName = primitive.a1n().d1o();
    if (serialName === primitiveName) {
      throw IllegalArgumentException().n2(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).j1() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkNameIsNotAPrimitive(serialName);
  return new (PrimitiveSerialDescriptor())(serialName, kind);
}
function error($this) {
  throw IllegalStateException().o('Primitive descriptor ' + $this.k25_1 + ' does not have elements');
}
var PrimitiveSerialDescriptorClass;
function PrimitiveSerialDescriptor() {
  if (PrimitiveSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, kind) {
        this.k25_1 = serialName;
        this.l25_1 = kind;
      }
      d1o() {
        return this.k25_1;
      }
      w1p() {
        return this.l25_1;
      }
      y1p() {
        return 0;
      }
      a1q(index) {
        error(this);
      }
      b1q(name) {
        error(this);
      }
      e1q(index) {
        error(this);
      }
      d1q(index) {
        error(this);
      }
      c1q(index) {
        error(this);
      }
      toString() {
        return 'PrimitiveDescriptor(' + this.k25_1 + ')';
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PrimitiveSerialDescriptor()))
          return false;
        if (this.k25_1 === other.k25_1 && equals(this.l25_1, other.l25_1))
          return true;
        return false;
      }
      hashCode() {
        return getStringHashCode(this.k25_1) + imul(31, this.l25_1.hashCode()) | 0;
      }
    }
    protoOf($).p1p = get_isNullable;
    protoOf($).x1p = get_isInline;
    protoOf($).z1p = get_annotations;
    initMetadataForClass($, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    PrimitiveSerialDescriptorClass = $;
  }
  return PrimitiveSerialDescriptorClass;
}
var ByteSerializerClass;
function ByteSerializer() {
  if (ByteSerializerClass === VOID) {
    class $ {
      constructor() {
        ByteSerializer_instance = this;
        this.m25_1 = new (PrimitiveSerialDescriptor())('kotlin.Byte', BYTE_getInstance());
      }
      a1n() {
        return this.m25_1;
      }
      n25(encoder, value) {
        return encoder.p1s(value);
      }
      b1n(encoder, value) {
        return this.n25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      c1n(decoder) {
        return decoder.f1r();
      }
    }
    initMetadataForObject($, 'ByteSerializer', VOID, VOID, [KSerializer()]);
    ByteSerializerClass = $;
  }
  return ByteSerializerClass;
}
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance === VOID)
    new (ByteSerializer())();
  return ByteSerializer_instance;
}
var ShortSerializerClass;
function ShortSerializer() {
  if (ShortSerializerClass === VOID) {
    class $ {
      constructor() {
        ShortSerializer_instance = this;
        this.o25_1 = new (PrimitiveSerialDescriptor())('kotlin.Short', SHORT_getInstance());
      }
      a1n() {
        return this.o25_1;
      }
      p25(encoder, value) {
        return encoder.q1s(value);
      }
      b1n(encoder, value) {
        return this.p25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      c1n(decoder) {
        return decoder.g1r();
      }
    }
    initMetadataForObject($, 'ShortSerializer', VOID, VOID, [KSerializer()]);
    ShortSerializerClass = $;
  }
  return ShortSerializerClass;
}
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance === VOID)
    new (ShortSerializer())();
  return ShortSerializer_instance;
}
var CharSerializerClass;
function CharSerializer() {
  if (CharSerializerClass === VOID) {
    class $ {
      constructor() {
        CharSerializer_instance = this;
        this.q25_1 = new (PrimitiveSerialDescriptor())('kotlin.Char', CHAR_getInstance());
      }
      a1n() {
        return this.q25_1;
      }
      r25(encoder, value) {
        return encoder.v1s(value);
      }
      b1n(encoder, value) {
        return this.r25(encoder, value instanceof Char() ? value.e4_1 : THROW_CCE());
      }
      s25(decoder) {
        return decoder.l1r();
      }
      c1n(decoder) {
        return new (Char())(this.s25(decoder));
      }
    }
    initMetadataForObject($, 'CharSerializer', VOID, VOID, [KSerializer()]);
    CharSerializerClass = $;
  }
  return CharSerializerClass;
}
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance === VOID)
    new (CharSerializer())();
  return CharSerializer_instance;
}
var FloatSerializerClass;
function FloatSerializer() {
  if (FloatSerializerClass === VOID) {
    class $ {
      constructor() {
        FloatSerializer_instance = this;
        this.t25_1 = new (PrimitiveSerialDescriptor())('kotlin.Float', FLOAT_getInstance());
      }
      a1n() {
        return this.t25_1;
      }
      u25(encoder, value) {
        return encoder.t1s(value);
      }
      b1n(encoder, value) {
        return this.u25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      c1n(decoder) {
        return decoder.j1r();
      }
    }
    initMetadataForObject($, 'FloatSerializer', VOID, VOID, [KSerializer()]);
    FloatSerializerClass = $;
  }
  return FloatSerializerClass;
}
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance === VOID)
    new (FloatSerializer())();
  return FloatSerializer_instance;
}
var UnitSerializerClass;
function UnitSerializer() {
  if (UnitSerializerClass === VOID) {
    class $ {
      constructor() {
        UnitSerializer_instance = this;
        this.v25_1 = new (ObjectSerializer())('kotlin.Unit', Unit_instance);
      }
      a1n() {
        return this.v25_1.a1n();
      }
      w25(encoder, value) {
        this.v25_1.u1n(encoder, Unit_instance);
      }
      b1n(encoder, value) {
        return this.w25(encoder, value instanceof Unit() ? value : THROW_CCE());
      }
      x25(decoder) {
        this.v25_1.c1n(decoder);
      }
      c1n(decoder) {
        this.x25(decoder);
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'UnitSerializer', VOID, VOID, [KSerializer()]);
    UnitSerializerClass = $;
  }
  return UnitSerializerClass;
}
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance === VOID)
    new (UnitSerializer())();
  return UnitSerializer_instance;
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = initBuiltins();
  }
}
//region block: exports
export {
  BooleanSerializer_getInstance as BooleanSerializer_getInstance2fsi2wywr82nt,
  ByteSerializer_getInstance as ByteSerializer_getInstance1nxlqf2s1e0d6,
  CharSerializer_getInstance as CharSerializer_getInstance1yoquzs1oia4q,
  DoubleSerializer_getInstance as DoubleSerializer_getInstance1wncowm4p8ecy,
  FloatSerializer_getInstance as FloatSerializer_getInstance1qugdr7bzigck,
  IntSerializer_getInstance as IntSerializer_getInstanceuhm8c1wku08l,
  LongSerializer_getInstance as LongSerializer_getInstance2fim4572ialei,
  ShortSerializer_getInstance as ShortSerializer_getInstanceiv7zxiav6sho,
  StringSerializer_getInstance as StringSerializer_getInstance11v9md0a7d9yk,
  UnitSerializer_getInstance as UnitSerializer_getInstance2ron9qqcvf5sr,
  PrimitiveDescriptorSafe as PrimitiveDescriptorSafe1r3pht5v1oaqu,
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptorkwnwsc78b2on,
  builtinSerializerOrNull as builtinSerializerOrNull180kp99qvlpex,
  checkNameIsNotAPrimitive as checkNameIsNotAPrimitive28vmhppr4nskt,
};
//endregion

//# sourceMappingURL=Primitives.mjs.map
